export const ACCENT_STORAGE_KEY = "console.accent.v1";

export const DEFAULT_ACCENT = {
  name: "Intellicar",
  hex: "#E40046",
  activeBg: "#FFE6EE",
  brandThemeId: "intellicar",
};

export const ACCENTS = [
  DEFAULT_ACCENT,
  { name: "BGauss", hex: "#78B466", activeBg: "#E8F5E3", brandThemeId: "bgauss" },
  { name: "Gold", hex: "#C9922A", activeBg: "#FBF3E3" },
  { name: "Indigo", hex: "#5B6AD4", activeBg: "#ECEFFE" },
  { name: "Jade", hex: "#2D9B6F", activeBg: "#E4F7EE" },
  { name: "Rose", hex: "#C2445A", activeBg: "#FCEAEC" },
];

export function loadStoredAccent() {
  try {
    const name = localStorage.getItem(ACCENT_STORAGE_KEY);
    return ACCENTS.find((a) => a.name === name) ?? DEFAULT_ACCENT;
  } catch {
    return DEFAULT_ACCENT;
  }
}

export function saveAccent(accent) {
  try {
    if (accent?.name) localStorage.setItem(ACCENT_STORAGE_KEY, accent.name);
  } catch {
    /* ignore */
  }
}

import { resolveBrandTheme } from "../themes/index.js";

export function isBrandThemeAccent(accent) {
  return resolveBrandTheme(accent) != null;
}
